import { SubscriptionFeature, Subscription } from '@content-api/api/subscription';

export const compareSubscriptions = (
  prev: Subscription,
  next: Subscription,
): 'DOWNGRADE' | 'UPGRADE' => {
  if (prev.rank > next.rank) return 'DOWNGRADE';
  return 'UPGRADE';
};

export const getSubscriptionDiff = (
  prev: Subscription,
  next: Subscription,
): SubscriptionFeature[] => {
  const prevFeatures = new Set(prev.subscriptionFeatures.map((feature) => feature.id));
  const nextFeatures = new Set(next.subscriptionFeatures.map((feature) => feature.id));
  const diff = new Set([...prevFeatures].filter((feature) => !nextFeatures.has(feature)));
  return Array.from(diff).map(
    (id) => prev.subscriptionFeatures.find((feature) => feature.id === id)!,
  );
};
